import { Dispatch } from '../components/architecture/frontend/index'
import { of } from 'rxjs'
import { filter, map, delay, tap } from 'rxjs/operators'
import _ from 'lodash'
import mutations from './Helpers/mutations'

Dispatch.getAction('reports.downloadExcelReport')
.pipe(
)
.subscribe(e => Dispatch.nextAction('Request.downloadExcelReport', { 
  type: 'mutation',
  query: mutations.DOWNLOAD_EXCEL_REPORT,
  variables: {
    startingDate: e
  } 
}))

Dispatch.getAction('Response.downloadExcelReport')
.pipe(
  filter(e => _.isNil(e.errors)),
  map(e => e.data.downloadExcelReport)
)
.subscribe(e => {
  window.open(e)
})

Dispatch.getAction('reports.downloadExcelAllClaimsReport')
.pipe(
)
.subscribe(e => Dispatch.nextAction('Request.downloadExcelAllClaimsReport', { 
  type: 'mutation',
  query: mutations.DOWNLOAD_EXCEL_ALL_CLAIMS_REPORT,
  variables: {
    startingDate: e.startingDate,
    claimsOnly: e.claimsOnly
  } 
}))

Dispatch.getAction('Response.downloadExcelAllClaimsReport')
.pipe(
  filter(e => _.isNil(e.errors)),
  map(e => e.data.downloadExcelAllClaimsReport)
)
.subscribe(e => {
  window.open(e)
})

Dispatch.getAction('reports.downloadExcelInvoiceRequiredReport')
.pipe(
)
.subscribe(e => Dispatch.nextAction('Request.downloadExcelInvoiceRequiredReport', { 
  type: 'mutation',
  query: mutations.DOWNLOAD_EXCEL_INVOICE_REQUIRED_REPORT,
  variables: {
  } 
}))

Dispatch.getAction('Response.downloadExcelInvoiceRequiredReport')
.pipe(
  filter(e => _.isNil(e.errors)),
  map(e => e.data.downloadExcelInvoiceRequiredReport)
)
.subscribe(e => {
  window.open(e)
})

Dispatch.getAction('view')
.pipe(
  filter(e => e.type === 'powerBIReports'),
)
.subscribe(e => {
  Dispatch.nextState('reports', null)
  Dispatch.nextAction('Request.powerBIReports', { 
    type: 'query',
    query: mutations.GET_POWER_BI_REPORTS,
    variables: {}
  })
})

Dispatch.getAction('Response.powerBIReports')
.pipe(
  filter(e => _.isNil(e.errors)),
  map(e => e.data.powerBIReports)
)
.subscribe(e => {
  Dispatch.nextState('reports', e)
})